export function addSettlementDays(baseIso, days, businessDaysOnly = false) {
  const date = new Date(baseIso || new Date().toISOString());
  const totalDays = Math.max(0, Number(days) || 0);

  if (totalDays === 0) return date.toISOString();

  if (!businessDaysOnly) {
    date.setDate(date.getDate() + totalDays);
    return date.toISOString();
  }

  // Días hábiles: el día de la semana se evalúa en hora LOCAL (AR), no UTC. Antes,
  // con getUTCDay(), una venta del viernes 22:00 ART (sábado en UTC) arrancaba a
  // contar desde sábado y la acreditación caía un día hábil más tarde. Bug T7.
  let remaining = totalDays;
  while (remaining > 0) {
    date.setDate(date.getDate() + 1);
    const dayOfWeek = date.getDay();
    const isBusinessDay = dayOfWeek !== 0 && dayOfWeek !== 6;
    if (isBusinessDay) remaining -= 1;
  }

  return date.toISOString();
}

export function getSaleSettlementDate(sale) {
  const createdAt = sale?.created_at || new Date().toISOString();
  const paymentMethod = sale?.payment_methods || null;
  if (!paymentMethod?.bank_id) return createdAt;
  const days = Math.max(0, Number(paymentMethod?.accreditation_days) || 0);
  const businessDaysOnly = Boolean(paymentMethod?.accreditation_business_days);
  return addSettlementDays(createdAt, days, businessDaysOnly);
}

export function getSaleSettlementAmount(sale) {
  const total = Math.max(0, Number(sale?.total) || 0);
  const paymentMethod = sale?.payment_methods || null;
  if (!paymentMethod?.bank_id) return total;

  const commissionPercentage = Math.max(0, Number(paymentMethod?.commission_percentage) || 0);
  const commissionAmount = total * (commissionPercentage / 100);
  return Math.max(0, total - commissionAmount);
}

export function estimateSettlementLookbackDays(paymentMethods = []) {
  return (paymentMethods || []).reduce((maxDays, method) => {
    const baseDays = Math.max(0, Number(method?.accreditation_days) || 0);
    const weekendPadding = method?.accreditation_business_days ? Math.ceil(baseDays / 5) * 2 + 2 : 0;
    return Math.max(maxDays, baseDays + weekendPadding);
  }, 0);
}
